export default function withExpiresSort(sortOp: any) {
  return sortOp.thenBy(
    (a: any, b: any) => {
      const isBefore = a.expiresOn.isBefore(b.expiresOn);

      return isBefore ? -1 : 1;
    },
  );
}
